import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add() {
    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    )

    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    const wrapper = event.target.closest(".incoming-invoice-line")
    if (!wrapper) return

    const destroyInput = wrapper.querySelector("input[name*='[_destroy]']")

    if (destroyInput) {
      destroyInput.value = "1"
      wrapper.classList.add("d-none")
    } else {
      wrapper.remove()
    }
  }
}